/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    h2: "h2",
    ol: "ol",
    li: "li",
    ul: "ul"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Set up your first semaphore"
    }), "\n", _jsxs(_components.p, {
      children: ["Start by ", _jsx(_components.a, {
        href: "/auth",
        children: "signing in to your account"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Once signed in, in the top right menu find the \"Services\" dropdown and navigate to \"Web Semaphores\"."
    }), "\n", _jsx(_components.h2, {
      children: "Creating a Web Semaphore"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "In the top right menu find the \"Services\" dropdown and navigate to \"Web Semaphores\"."
      }), "\n", _jsx(_components.li, {
        children: "Click on \"Create Semaphore\""
      }), "\n", _jsx(_components.li, {
        children: "Fill out a descriptive title"
      }), "\n", _jsx(_components.li, {
        children: "Fill out the max value property. If you are just starting and want to get a quick impression, choose a small value such as 3 or 5."
      }), "\n", _jsx(_components.li, {
        children: "Choose the HTTP method and the callback url"
      }), "\n", _jsx(_components.li, {
        children: "Click ok"
      }), "\n", _jsx(_components.li, {
        children: "You will be taken back to the list of semaphores"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Note that all settings are editable at any time so don't hesitate to experiment."
    }), "\n", _jsx(_components.p, {
      children: "See also:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/api/semaphore",
          children: "Semaphore Configuration"
        })
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
